<template>
  <v-sheet class="fin-archetype-properties">
    <v-row>
      <v-col cols="6" md="5" sm="6">
        <p :key="id"
           style="font-size: 14px"
           :class="{activeHint: property === selectedProp}"
           v-for="(property, id) in archetypeClassifications"
           @click="showHint(property)"
           @mouseover="showPointer(property)">

          <v-icon :color="$finColors.primaryDark"
                  class="d-inline-block">
            {{ property.icon }}
          </v-icon>
          <span
            :class="{hoverProperties: property === hoveredProp}"> {{
              property.values[classificationProps[property.name]].title
            }} </span>
        </p>
      </v-col>
      <v-col cols="6" md="5" sm="6">
        <p v-if="$vuetify.breakpoint.smAndUp" class="activeHint"> {{ hintTitle }} </p>
        <p class="tooltip"> {{ hint }} </p>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
/** Use the `ArchetypeProperties` component for displaying all specified properties; one beneath the other. */
export default {
  name: 'finArchetypeProperties',
  data () {
    return {
      selectedProp: this.archetypeClassifications[0],
      hoveredProp: null
    }
  },
  props: {
    /** the selected classification properties as object to display */
    classificationProps: {
      type: Object
    },
    resultScreen: {
      type: Boolean
    },
    /** a list of archetype classifications */
    archetypeClassifications: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    showHint (property) {
      if (!this.resultScreen) {
        this.selectedProp = property
      }
    },
    showPointer (property) {
      if (!this.resultScreen) {
        this.hoveredProp = property
      }
    }
  },
  computed: {
    hintTitle () {
      return this.selectedProp ? this.selectedProp.values[this.classificationProps[this.selectedProp.name]].title : ''
    },
    hint () {
      return this.selectedProp ? this.selectedProp.values[this.classificationProps[this.selectedProp.name]].tooltip.text : ''
    },
  }
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 11px;
}

.tooltip {
  font-size: 14px;
  color: $fin-color-primary-dark;
}

.v-image {
  vertical-align: middle;
  margin-right: 8px;
}

.v-icon {
  top: -3px;
  margin-top: 0 !important;
}

.activeHint {
  font-weight: bold;
}

.hoverProperties {
  cursor: pointer;
}
</style>
